exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".marked[data-v-4c7df941] {\n  color: #06c6ff;\n}\n.service-steps ol[data-v-4c7df941] {\n  margin-left: 20px;\n  list-style-type: auto;\n}\n.service-steps ol li[data-v-4c7df941] {\n  padding-left: 0;\n}\n.service-steps ol li[data-v-4c7df941]::before {\n  display: none;\n}\n.service-steps ol li[data-v-4c7df941]::marker {\n  color: #06c6ff;\n}\n.service-process[data-v-4c7df941], .service-dedicated[data-v-4c7df941] {\n  margin-top: -20px;\n}", ""]);

// exports
